/**
 * Handles number and undefined values
 * @param {string | number | null} value - Any value
 * keywords:
 */
const asString = (value?: string | number | null): string => `${value ?? '-'}`;

export default asString;
